var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuscaPreta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.999,
    height: 16,
    viewBox: "0 0 15.999 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 15.999,
    height: 16,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.999,
    height: 16,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(114,119,117)",
    fillRule: "evenodd",
    d: "M2.09887695 1.57061768C4.57818604-.62878418 8.34204102-.51489258 10.6838379 1.8303833c2.1375122 2.14483643 2.43579102 5.51116943.70880127 7.99841309.25097656.05212402.48138428.17608642.663208.35681152l3.55438233 3.55596924c.5164795.51654053.5164795 1.35394287 0 1.87042236-.51654053.5164795-1.35394287.5164795-1.87042236 0l-3.55432129-3.55438232c-.18121338-.1815796-.30548096-.41204834-.35760498-.66320801-2.72106934 1.89215088-6.4453125 1.33581543-8.49468994-1.2689209-2.0493164-2.60479736-1.71362305-6.35540771.76568603-8.5548706zm.85565186 7.99249267c1.82513428 1.82513428 4.78424072 1.82519531 6.609375.00006104h-.00158692c1.8225708-1.82598877 1.82330323-4.78271485.00158692-6.60961914-1.82513428-1.82507325-4.78424072-1.82501221-6.609375.00012207-1.82507324 1.82513427-1.82507324 4.78424072 0 6.60943603z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuscaPreta);
export default __webpack_public_path__ + "static/media/busca_preta.c7f4b875f0a7b233a54adc9fbc944b63.svg";
export { ForwardRef as ReactComponent };